import { render, staticRenderFns } from "./Bell.vue?vue&type=template&id=ffb5bd3c&scoped=true&"
import script from "./Bell.vue?vue&type=script&lang=js&"
export * from "./Bell.vue?vue&type=script&lang=js&"
import style0 from "./Bell.vue?vue&type=style&index=0&id=ffb5bd3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb5bd3c",
  null
  
)

export default component.exports